module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/small/piacenza.f338c14a635acb49b9ac5e432763a7b5.jpg";